import React, { Fragment } from 'react';
import {
  List,
  Edit,
  Create,
  Datagrid,
  FunctionField,
  NumberField,
  EditButton,
  DisabledInput,
  TextField,
  SelectInput,
  SimpleForm,
  NumberInput,
  ReferenceInput,
  ArrayInput,
  ArrayField,
  ReferenceField,
  SimpleFormIterator,
  CardActions,
  ListButton,
} from 'react-admin';
import BulkDeleteButton from './ui/BulkDeleteButton';

const AutopostcategoriesBulkActionButtons = props => (
  <Fragment>
      <BulkDeleteButton {...props} />
  </Fragment>
);

const AutopostcategoriesEditActions = ({ basePath, data, resource }) => (
  <CardActions>
      <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
  </CardActions>
);

const CategoryTitle = ({ record }) => {
  return <span>Category {record ? `"${record.id}"` : ''}</span>;
};


const autopost_types = [
  { id: 'articles', name: 'articles' },
  { id: 'facebook', name: 'facebook' },
  { id: 'galleries', name: 'galleries' },
  { id: 'videos', name: 'videos' },
];

const CategoryWeigts = ({ ids, data, basePath  }) => (
  <div>
  {ids.map(id =>
      <span key={id} className='category-span'>
        <ReferenceField record={data[id]} basePath={basePath} source="ref" reference="articles/categories-choice">
          <TextField source="name" />
        </ReferenceField>:
        <TextField record={data[id]} label="Type" source="weight" />,
      </span>
  )}
  </div>
);

export const AutopostcategoriesList = props => (
  <List title="Auto-post Categories" bulkActionButtons={<AutopostcategoriesBulkActionButtons />} {...props} perPage={25}>
    <Datagrid>
      <TextField label="Type" source="type" />
      <FunctionField
        sortable={false}
        source="hours"
        label="Hours"
        render={(record, source) => {
          return (
            <span>
              {' '}
              {record['hours'].from} - {record['hours'].to}
            </span>
          );
        }}
      />
      <ArrayField source="categories">
        <CategoryWeigts />
      </ArrayField>
      <NumberField label="Order" source="order" />
      <EditButton />
    </Datagrid>
  </List>
);

export const AutopostcategoriesEdit = props => {
  return (
    <Edit title={<CategoryTitle />} actions={<AutopostcategoriesEditActions />} {...props}>
      <SimpleForm>
        <DisabledInput source="id" />
        <SelectInput source="type" allowEmpty={true} choices={autopost_types} />
        <NumberInput label="Hour from" source={`hours.from`} step={1} />
        <NumberInput label="Hour to" source={`hours.to`} step={1} />
        <NumberInput label="Order" source={`order`} step={1} />
        <ArrayInput source={`categories`} className="inline-form">
          <SimpleFormIterator>
            <ReferenceInput
              label="Category"
              source="ref"
              reference="articles/categories-choice"
              allowEmpty
            >
              <SelectInput source="name" />
            </ReferenceInput>
            <NumberInput label="Weight" source={`weight`} step={0.1} />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  );
};

export const AutopostcategoriesCreate = props => {
  return (
    <Create title={<CategoryTitle />} actions={<AutopostcategoriesEditActions />} {...props}>
      <SimpleForm>
        <SelectInput source="type" allowEmpty={true} choices={autopost_types} />
        <NumberInput label="Hour from" source={`hours.from`} step={1} />
        <NumberInput label="Hour to" source={`hours.to`} step={1} />
        <NumberInput label="Order" source={`order`} step={1} />
        <ArrayInput source={`categories`}>
          <SimpleFormIterator>
          <ReferenceInput
            label="Category"
            source="ref"
            reference="articles/categories"
            allowEmpty
            style={{ float: 'left', padding: '0 12px 0 0' }}
          >
            <SelectInput source="name" />
          </ReferenceInput>
          <NumberInput label="Weight" source={`weight`} step={0.1} style={{ float: 'left', padding: '0 12px 0 0' }} />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
};



// WEBPACK FOOTER //
// ./src/resources/autopostcategories.js